import { render } from "./ClicksChart.vue?vue&type=template&id=3d13d664&ts=true"
import script from "./ClicksChart.vue?vue&type=script&lang=ts"
export * from "./ClicksChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__